import { PLATFORM_DATA_CONFIG } from 'common/constants';
import { useTracking } from 'common/utils';
import { useState } from 'react';
import { useAuth } from 'src/auth';

const useProfileDrawer = () => {
  const { user, signout } = useAuth();
  const { track } = useTracking();
  const [isOpenSelectLanguegeDrawer, setIsOpenSelectLanguegeDrawer] =
    useState(false);

  const handleClickOnEditProfile = () => {
    track('Profile Drawer - Clicked to edit profile');
    window
      .open(`${PLATFORM_DATA_CONFIG.ACCOUNTS_URI}/app/profile`, '_blank')
      ?.focus();
  };

  const handleClickLegalDocuments = () => {
    track('Profile Drawer - Clicked to legal documents');
    window
      .open(
        `${PLATFORM_DATA_CONFIG.ACCOUNTS_URI}/app/legaldocs/${
          user?.country_code ?? 'US'
        }`,
        '_blank',
      )
      ?.focus();
  };

  const handleClickOnLogout = () => {
    track('Profile Drawer - Clicked to logout');
    signout();
  };

  const handleClickOnSelectLanguage = () => {
    track('Profile Drawer - Clicked to select language');
    setIsOpenSelectLanguegeDrawer(true);
  };

  const handleCloseSelectLanguageDrawer = () => {
    track('Profile Drawer - Closed select language drawer');
    setIsOpenSelectLanguegeDrawer(false);
  };

  return {
    handleClickOnEditProfile,
    handleClickLegalDocuments,
    handleClickOnLogout,
    handleClickOnSelectLanguage,
    handleCloseSelectLanguageDrawer,
    isOpenSelectLanguegeDrawer,
  };
};

export { useProfileDrawer };
